import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { IoIosMail, IoIosCall, IoIosHome, IoIosRefresh } from "react-icons/io";

const Section = styled.section`
  border: red solid 0px;
  background-color: #282c34;
  
  padding-top: 100px;
  padding-bottom: 100px;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const SpanAbsoluteIcon = styled.span`
  position: absolute;
`;
const SpanAbsoluteText = styled.span`
  position: absolute;
  left:20px;
`;
const SpanIndent90 = styled.span`
  margin-left: 90px;
  padding-left: 1%; // 패딩을 1% 넣어주면 화면 폭이 크게 넓어질 때 미세하게 간격을 키워줄 수 있다.
  width: 100%;  // 패딩을 1% 넣어줬기 때문에 패딩이 커지면 텍스트가 본 영역을 벗어나 줄바꿈이 일어날 수 있다. 
                // 최대한 줄바꿈이 늦게 일어나게 텍스트 영역의 너비를 최대한 잡아줬다.
  word-break: break-all;  // 화면 폭이 좁은 경우 이메일 주소가 영역 밖으로 넘어가는 경우가 있어 breakable 로 지정
`;
class SectionLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: 0,
    };
    this.resetIframe = this.resetIframe.bind(this);
  }
  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  render() {
    return (
      <div className="SectionLocationContainer" id="location">
        <Section className="SectionLocation">
          <ContainerFluid className="ContainerFluid">

            <p style={{marginTop:0,marginBottom:0,fontSize:'16px',fontWeight:'bold',color:'rgb(255, 255, 255)',textTransform:'uppercase'}}>
              Location
            </p>
            <h1 style={{marginTop:0,marginBottom:0,fontSize:'32px',color:'rgb(255, 196, 64)'}}>
              오시는 길
            </h1>

            <div style={{maxWidth:'100%',marginTop:'16px'}}>
              <iframe key={this.state.random} src="/naver_dynamic_map_v3.html" style={{border : 'white solid 0px', width:'100%', height:'400px'}}>
                <p>Your browser does not support iframes.</p>
              </iframe>
            </div>

            <p style={{position:'relative', margin:'0px',fontSize:'16px',color:'rgb(255, 255, 255)'}}>
              <span style={{display:'flex', justifyContent: 'space-between'}}>
                <SpanAbsoluteIcon><IoIosHome style={{position:'relative',top:'3px'}}/></SpanAbsoluteIcon>
                <SpanAbsoluteText>주소</SpanAbsoluteText>
                <SpanIndent90>서울시 서초구 강남대로8길 16-3</SpanIndent90>
                <span onClick={this.resetIframe}>
                  <IoIosRefresh/>
                </span>
              </span>
              <SpanAbsoluteIcon><IoIosCall style={{position:'relative',top:'3px'}}/></SpanAbsoluteIcon>
              <SpanAbsoluteText>전화번호</SpanAbsoluteText>
              <SpanIndent90>070-7633-2815</SpanIndent90>
              <br/>
              <span style={{display:'flex', justifyContent: 'space-between'}}>
                <SpanAbsoluteIcon><IoIosMail style={{position:'relative',top:'3px'}}/></SpanAbsoluteIcon>
                <SpanAbsoluteText>이메일</SpanAbsoluteText>
                <SpanIndent90>contact@bomsystems.co.kr</SpanIndent90>
              </span>
            </p>

          </ContainerFluid>
        </Section>
      </div>
    );
  }
}

export default SectionLocation;
